import React from 'react';

import Wrapper from './FrontendPlatformWrapper';

// eslint-disable-next-line react/display-name,react/prop-types,func-names
export default function ({ element }) {
  return <Wrapper>{element}</Wrapper>;
}
